const reactToPrintModalQRCode = {
  btnLabel: 'print out'
};

export default reactToPrintModalQRCode;
